// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__RllE1","checkboxCol":"Table_checkboxCol__192L6","emailCol":"Table_emailCol__3RWQx","actionCol":"Table_actionCol__1DA4i"};